import React, { Component } from "react";
import htmlParse from "html-react-parser";
import IAgreeTerms from "../../common/components/pageBlocks/declaration/iAgreeTerms";
import HdfcHeader from "../../common/components/pageBlocks/hdfcHeader";
import ModalPopUp from "../../common/components/pageBlocks/modalPopUp";
import commonContext, { AppContext } from "../../common/context/common";
import InputForm from "../../common/components/html/inputForm";
import OtpPopUp from "../../common/components/otpPopUp";
import IAgreeTermsInsurence from "../../common/components/pageBlocks/declaration/iAgreeTermsInsurence";
import { leadType } from "../../app";
import { ALDDApis } from "../apis/aLDDApis";
import { CommonApis } from "../../common/apis/commonApis";
import { Authorization } from "../../common/utils/authorization";

interface IProps {
    history: any;
}
interface IState {
    IAgreeToTermSwitch: boolean;
    IAgreeToTerm: boolean;
    IAgreeToTermInsuranceSwitch: boolean;
    IAgreeToTermInsurance: boolean;
    insuranceSwitch: boolean;
    otpPopUpSwitch: boolean;
    IAgreeToTermError: boolean;
    IAgreeToTermInsuranceError: boolean;
    captchaError: boolean;
}
export class Declaration extends Component<IProps, IState> {
    static contextType = commonContext;
    lead: leadType;
    setLead: Function;
    apis: ALDDApis;
    cAPI: CommonApis;
    formRef: any;
    authKeeper: Authorization;
    constructor(props: IProps) {
        super(props);
        this.state = {
            IAgreeToTermSwitch: false,
            IAgreeToTerm: false,
            IAgreeToTermInsuranceSwitch: false,
            IAgreeToTermInsurance: false,
            otpPopUpSwitch: false,
            insuranceSwitch: false,
            IAgreeToTermError: false,
            IAgreeToTermInsuranceError: false,
            captchaError: false,
        };
        this.formRef = React.createRef();
    }
    async componentDidMount() {
        window.scrollTo(0, 0);
        this.setLead = (this.context as AppContext).setLead;
        this.cAPI = (this.context as AppContext).commonAPI as CommonApis;
        this.apis = (this.context as AppContext).apis as ALDDApis;
        this.lead = (this.context as AppContext).lead as leadType;
        const apiData = await this.cAPI.getCaptcha(this.lead);
        this.authKeeper = (this.context as AppContext)
            .authKeeper as Authorization;
        this.setLead(apiData?.result);
    }
    handleOnSubmit = async (e) => {
        e.preventDefault();
        this.lead = (this.context as AppContext).lead as leadType;
        this.setState({
            IAgreeToTermError: false,
            IAgreeToTermInsuranceError: false,
            captchaError: false,
        });
        if (!this.state.IAgreeToTerm) {
            return this.setState({ IAgreeToTermError: true });
        }
        if (!this.state.IAgreeToTermInsurance) {
            if (this.lead.motorInsuranceAvailed || this.lead.insuranceAvailed) {
                return this.setState({ IAgreeToTermInsuranceError: true });
            }
        }
        const apiData = await this.cAPI.validateCaptcha({
            ...this.lead,
            input: this.lead.captchaInput,
        });
        if (apiData.error) {
            if (apiData.error.error) {
                return this.setState({ captchaError: true });
            }
        }
        this.setLead({ termCondition: true });
        const createTransactionAgreement = await this.apis.createTransactionAgreement(
            {
                ...this.lead,
                termsAndConditions: true,
            }
        );
        console.log(createTransactionAgreement);
        if (createTransactionAgreement.error?.error) {
            this.setLead({
                ...createTransactionAgreement.result,
                confirmStatus: false,
            });
            return this.props.history.push("confirmation");
        }
        if (this.lead.typeOfCustomer != "ETB") {
            this.setLead({
                ...createTransactionAgreement.result,
            });
            return this.setState({ otpPopUpSwitch: true });
        } else {
            this.setLead({
                ...createTransactionAgreement.result,
                // confirmStatus: true,
            });
            return this.props.history.push("final-verify");
            // e.currentTarget.submit();
        }
    };
    handleOnOTPSubmit = async () => {
        this.lead = (this.context as AppContext).lead as leadType;
        const apiData = await this.apis.finalSubmit(this.lead);
        if (apiData.error.error) {
            this.setLead({ confirmStatus: false });
        } else if (!apiData.result.loanAvailed) {
            this.setLead({ confirmStatus: true });
        } else {
            this.setLead({ confirmStatus: false });
        }
        this.props.history.push("confirmation");
    };
    handleOnResend = async () => {
        this.lead = (this.context as AppContext).lead as leadType;
        await this.cAPI.resendFinalOtp(this.lead);
    };
    render() {
        this.lead = (this.context as AppContext).lead as leadType;
        this.authKeeper = (this.context as AppContext)
            .authKeeper as Authorization;
        return (
            <>
                <div className="wrapper">
                    <HdfcHeader />
                    <section className="declaration-wrap mt-110">
                        <div className="container mx-auto px-5">
                            <h1 className="openSans-Reg text-black my-5 text-3xl md:text-3xl lg:text-3xl xl:text-4xl">
                                Declaration
                            </h1>
                            {/* <!-- <a href="javascript:;" className="modal-open mr-3" data-toggle="modal" data-target="termsConditionModal">sarva-suraksha-info</a> --> */}
                            <form
                                onSubmit={(e) => this.handleOnSubmit(e)}
                                ref={this.formRef}
                                action={`${process.env.REACT_APP_COMMON_API}/common-api/net-banking-request`}
                                method="POST"
                            >
                                <div className="custom-inputs tnc-general-inputs mt-4 mb-8 openSans-SemiBold text-sm md:text-lg xl:text-xl blue-link-color">
                                    <label className="inline-flex">
                                        <input
                                            type="checkbox"
                                            onChange={() =>
                                                this.setState({
                                                    IAgreeToTerm: !this.state
                                                        .IAgreeToTerm,
                                                })
                                            }
                                            checked={this.state.IAgreeToTerm}
                                        />
                                        <span></span>
                                        <span className="ml-2 text-sm md:text-base lg:text-xl text-black openSans-Reg">
                                            I agree to and accept
                                            <a
                                                href="javascript:;"
                                                className="modal-open blue-link-color no-underline hover:underline hover:text-black transition-all openSans-SemiBold"
                                                data-toggle="modal"
                                                data-target="termsConditionModal"
                                                onClick={() =>
                                                    this.setState({
                                                        IAgreeToTermSwitch: true,
                                                    })
                                                }
                                            >
                                                (i) The application filled in
                                                previous pages, (ii) Most
                                                important terms and conditions,
                                                (iii) Acceptance of fees and
                                                charges, (iv) Standing
                                                instruction for repayment of
                                                monthly instalment, (v)
                                                Relationship with directors of
                                                banks
                                            </a>
                                        </span>
                                    </label>
                                </div>
                                <span
                                    className={`${
                                        this.state.IAgreeToTermError
                                            ? ""
                                            : "hidden"
                                    } error-msg-relative text-red-600 openSans-Reg text-xs md:text-sm lg:text-sm xl:text-sm`}
                                >
                                    Please check
                                </span>
                                {this.lead.motorInsuranceAvailed ||
                                this.lead.insuranceAvailed ? (
                                    <>
                                        <div className="custom-inputs tnc-sarvsuraksha-inputs mt-4 mb-8 openSans-SemiBold text-sm md:text-lg xl:text-xl blue-link-color">
                                            <label className="inline-flex">
                                                <input
                                                    type="checkbox"
                                                    onChange={() =>
                                                        this.setState({
                                                            IAgreeToTermInsurance: !this
                                                                .state
                                                                .IAgreeToTermInsurance,
                                                        })
                                                    }
                                                    checked={
                                                        this.state
                                                            .IAgreeToTermInsurance
                                                    }
                                                />
                                                <span></span>
                                                <span className="ml-2 text-sm md:text-base lg:text-xl text-black openSans-Reg">
                                                    I agree to and accept all
                                                    terms & conditions for{" "}
                                                    <a
                                                        href="javascript:;"
                                                        className="modal-open blue-link-color no-underline hover:underline hover:text-black transition-all openSans-SemiBold"
                                                        data-toggle="modal"
                                                        data-target="termsConditionModal"
                                                        onClick={() =>
                                                            this.setState({
                                                                insuranceSwitch: true,
                                                            })
                                                        }
                                                    >
                                                        {" "}
                                                        {this.lead
                                                            .motorInsuranceAvailed &&
                                                        this.lead
                                                            .insuranceAvailed
                                                            ? "(i) Sarv Suraksha Insurance,  (ii) HDFC ERGO Motor"
                                                            : this.lead
                                                                  .insuranceAvailed
                                                            ? "(i) Sarv Suraksha Insurance,"
                                                            : this.lead
                                                                  .insuranceAvailed
                                                            ? "(ii) HDFC ERGO Motor"
                                                            : "(i) HDFC ERGO Motor"}
                                                    </a>
                                                </span>
                                            </label>
                                        </div>
                                        <span
                                            className={`${
                                                this.state
                                                    .IAgreeToTermInsuranceError
                                                    ? ""
                                                    : "hidden"
                                            } error-msg-relative text-red-600 openSans-Reg text-xs md:text-sm lg:text-sm xl:text-sm`}
                                        >
                                            Please check
                                        </span>
                                    </>
                                ) : (
                                    ""
                                )}
                                <div className="flex flex-wrap">
                                    <div className="m-3 w-full md:w-3/12 inline-flex justify-center md:justify-start">
                                        {this.lead.img
                                            ? htmlParse(this.lead.img)
                                            : ""}
                                    </div>
                                    <div className="w-full md:w-3/12 relative">
                                        <InputForm
                                            label="Enter Code"
                                            handlerOnChange={(e) =>
                                                this.setLead({
                                                    captchaInput:
                                                        e.target.value,
                                                })
                                            }
                                            errorText="Please Input Correct Captcha Code"
                                            error={this.state.captchaError}
                                            errorClass="input-info-fix"
                                        />
                                    </div>
                                </div>
                                <input
                                    type="text"
                                    name="customerId"
                                    value={this.lead.customerId}
                                    hidden
                                />
                                <input
                                    type="text"
                                    name="uniqueReferenceNumber"
                                    value={this.lead.uniqueReferenceNo}
                                    hidden
                                />
                                <input
                                    type="text"
                                    name="authorization"
                                    value={this.authKeeper.authorization}
                                    hidden
                                />
                                <div className="w-full flex flex-wrap my-8">
                                    <button className="button-blue-bg text-white py-2 px-4 rounded text-base lg:text-lg xl:text-xl button-blue mb-2 mr-0 sm:mr-2 md:mr-2 lg:mr-3 xl:mr-4">
                                        Continue
                                    </button>
                                </div>
                            </form>
                        </div>
                    </section>
                </div>
                {/* <!-- Terms & Conditions Popup Start --> */}
                {this.state.IAgreeToTermSwitch ? (
                    <ModalPopUp
                        onclickhandler={() =>
                            this.setState({ IAgreeToTermSwitch: false })
                        }
                    >
                        <IAgreeTerms
                            onclickhandler={() =>
                                this.setState({
                                    IAgreeToTermSwitch: false,
                                    IAgreeToTerm: true,
                                })
                            }
                        />
                    </ModalPopUp>
                ) : (
                    ""
                )}
                {/* <!-- Terms & Conditions Popup End -->  */}
                {/* insurence popup start */}
                {this.state.insuranceSwitch ? (
                    <ModalPopUp
                        onclickhandler={() =>
                            this.setState({ insuranceSwitch: false })
                        }
                    >
                        <IAgreeTermsInsurence
                            onclickhandler={() =>
                                this.setState({
                                    IAgreeToTermInsurance: true,
                                    insuranceSwitch: false,
                                })
                            }
                            onclickhandlerCancel={() =>
                                this.setState({
                                    insuranceSwitch: false,
                                })
                            }
                        />
                    </ModalPopUp>
                ) : (
                    ""
                )}
                {/* insurence popup end */}
                {/* <!-- OTP Popup Start --> */}
                {this.state.otpPopUpSwitch ? (
                    <OtpPopUp
                        onClose={() => this.setState({ otpPopUpSwitch: false })}
                        handleOnOTPSubmit={() => this.handleOnOTPSubmit()}
                        resendOTP={() => this.handleOnResend()}
                    />
                ) : (
                    ""
                )}

                {/* <!-- OTP Popup End -->  */}
            </>
        );
    }
}

export default Declaration;
